export default "__VITE_ASSET__Bsh9_aRr__"